import React, { Component } from 'react';
import { Button, Modal, message } from 'antd';
import { connect } from 'react-redux';

import EditorForm from './EditorForm';
import { createPage, editPage } from '../../../../../actions';
import CKEditor from '../../../../../components/elements/Editor';

class Editor extends Component {
  state = {
    fields: {
      newTitle: {
        value: this.props.page.title,
      },
      newLanguage: {
        value: this.props.page.language,
      },
      newFeaturedImage: {
        value: this.props.page.featuredImage,
      },
    },
    newContent: this.props.page.content,
    responseList: [],
  }

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  }

  receiveHtml = ({ data }) => {
    this.setState({
      newContent: data,
      responseList: [],
    });
  }

  handleOk = () => {
    const type = this.props.type;
    const { fields, newContent } = this.state;
    if (type === 'create') {
      Modal.confirm({
        title: 'Bạn chắc chắn tạo trang mới?',
        okText: 'Có',
        okType: 'danger',
        cancelText: 'Không',
        onOk: () => {
          this.props.createPage({
            data: {
              title: fields.newTitle.value,
              featuredImage: fields.newFeaturedImage.value,
              language: fields.newLanguage.value,
              content: newContent,
            },
            response: {
              success: async () => {
                message.success('Tạo trang mới thành công');
                this.props.closeEditor();
              },
              failure: async (msg = 'Tạo trang mới không thành công') => {
                message.error(msg);
              },
            },
          });
        },
        onCancel: () => {

        },
      });
    } else if (type === 'edit') {
      Modal.confirm({
        title: 'Bạn chắc chắn sửa trang?',
        okText: 'Có',
        okType: 'danger',
        cancelText: 'Không',
        onOk: () => {
          this.props.editPage({
            _id: this.props.page._id,
            data: {
              title: fields.newTitle.value,
              featuredImage: fields.newFeaturedImage.value,
              language: fields.newLanguage.value,
              content: newContent,
            },
            response: {
              success: async () => {
                message.success('Sửa trang thành công');
                this.props.closeEditor();
              },
              failure: async (msg = 'Sửa trang không thành công') => {
                message.error(msg);
              },
            },
          });
        },
        onCancel: () => {

        },
      });
    }
  }

  handleCancel = () => {
    Modal.confirm({
      title: 'Bạn chắc chắn hủy tác vụ?',
      okText: 'Có',
      okType: 'danger',
      cancelText: 'Không',
      onOk: () => {
        this.props.closeEditor();
      },
      onCancel: () => {

      },
    });
  }

  render() {
    const { fields, newContent } = this.state;
    const { page: { title, content, featuredImage, language }, type, info } = this.props;
    const { newTitle, newFeaturedImage, newLanguage } = fields;
    const isCreate = type === 'create';
    const disabled = newTitle.value === '' || newTitle.value === undefined ||
                     newContent === '' || newContent === undefined || newContent === '<p ><br></p>' ||
                     newLanguage.value === '' || newLanguage.value === undefined ||
                     (newFeaturedImage.value === featuredImage
                      && newTitle.value === title
                      && newContent === content
                      && newLanguage.value === language);

    return (
      <div>
        <EditorForm
          {...fields}
          onChange={this.handleFormChange}
          formItemLayout={this.props.formItemLayout}
          tailFormItemLayout={this.props.tailFormItemLayout}
          role={info.role}
        />
        <CKEditor
          placeholder="Nội dung tin"
          onChange={this.receiveHtml}
          value={content}
        />
        <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <Button type="primary" onClick={this.handleCancel}>Hủy</Button>
          {' '}
          <Button type="primary" onClick={this.handleOk} disabled={disabled}>{isCreate ? 'Tạo trang' : 'Chỉnh sửa'}</Button>          
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  info: state.user.info,
});

const mapDispatchToProps = {
  createPage,
  editPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Editor);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Pages/Editor/Editor.js